import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const CustomIntegrationTimeline: React.FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='Custom MCP' {...props} />
}
